import React, { useState, useRef, useEffect } from 'react';
import './CustomDropdown.css';

const AnnuitySchemeDropdown = ({ options, value, onChange, placeholder, name }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (searchTerm) {
      const filtered = options.filter(option =>
        option.schemeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        option.schemeDescription.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  }, [searchTerm, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onChange({ target: { name, value: option.schemeName } });
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSearchTerm('');
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const selectedOption = options.find(opt => opt.schemeName === value);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div
        className={`custom-dropdown-toggle ${isOpen ? 'open' : ''}`}
        onClick={handleToggle}
      >
        <span className={value ? 'selected-value' : 'placeholder'}>
          {value || placeholder}
        </span>
        <i className={`fas fa-chevron-down ${isOpen ? 'rotate' : ''}`}></i>
      </div>
      {isOpen && (
        <div className="custom-dropdown-menu" style={{ maxHeight: '400px' }}>
          <div className="custom-dropdown-search">
            <input
              type="text"
              placeholder="Search scheme..."
              value={searchTerm}
              onChange={handleSearchChange}
              autoFocus
              className="search-input"
            />
            <i className="fas fa-search search-icon"></i>
          </div>
          <div className="custom-dropdown-options">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={index}
                  className={`custom-dropdown-option ${value === option.schemeName ? 'selected' : ''}`}
                  onClick={() => handleSelect(option)}
                  style={{ padding: '1rem' }}
                >
                  <div style={{ fontWeight: '600', marginBottom: '0.5rem', color: '#333' }}>
                    {option.schemeName}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#666', lineHeight: '1.5', whiteSpace: 'pre-line' }}>
                    {option.schemeDescription.split('\n').slice(0, 3).join('\n')}
                    {option.schemeDescription.split('\n').length > 3 && '...'}
                  </div>
                </div>
              ))
            ) : (
              <div className="custom-dropdown-option no-results">
                No results found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AnnuitySchemeDropdown;

